import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const EkiDown = () => {
  const tileId = useTargetAccumulatorTileId();
  const ekiDown = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.ekiDown);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('EkiDown') ?? false,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleEkiDown = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'EkiDown changed', isDefined(value) ? String(value) : 'null');

    return checkTargetAccumulatorWithTradeCapture({
      ekiDown: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.ekiDown">
      <TradeCaptureValidationWrapper validation={validation?.ekiDown}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          allowNegative={false}
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          value={ekiDown}
          maxDecimals={9}
          onChange={handleEkiDown}
          size="sm"
          data-e2e="eki-down"
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default EkiDown;
